import React from 'react';

type ArrowIconProps = {
  color?: string;
};

export const SliderLeftArrow: React.FC<ArrowIconProps> = ({
  color = '#2E2E2E',
}) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M12 4L4 12L12 20" stroke={color} strokeWidth="2" />
      <path d="M21 12L4 12" stroke={color} strokeWidth="2" />
    </g>
  </svg>
);
